import { useEffect } from 'react'
import { WorkspaceModeRenderer } from './WorkspaceModeRenderer'
import { GoalSelectionWizard } from './GoalSelectionWizard'
import { useAuthStore } from '@/stores/authStore'
import { useProjectStore } from '@/stores/projectStore'
import { useWorkspaceStore } from '@/stores/workspaceStore'
import { useJourneyStore } from '@/stores/journeyStore'
import { LayoutGrid } from 'lucide-react'

interface WorkspacePageProps {
  onViewChange?: (view: string) => void
}

export function WorkspacePage({ onViewChange }: WorkspacePageProps) {
  const { currentAccount } = useAuthStore()
  const { currentProject } = useProjectStore()
  const { showGoalWizard, setShowGoalWizard } = useWorkspaceStore()
  const { fetchJourney, hasGoal, isLoading: isJourneyLoading } = useJourneyStore()

  // Fetch journey data and prompt for goal selection if needed
  useEffect(() => {
    if (!currentAccount?.id || !currentProject?.id) return
    fetchJourney(currentAccount.id, currentProject.id).then(() => {
      if (!isJourneyLoading && !hasGoal()) {
        setShowGoalWizard(true)
      }
    })
  }, [currentAccount?.id, currentProject?.id, fetchJourney])

  if (!currentAccount || !currentProject) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <LayoutGrid size={48} className="mx-auto mb-3" style={{ color: 'var(--color-warm-300)' }} />
          <p className="text-text-muted">Please select a project to access the Workspace</p>
        </div>
      </div>
    )
  }

  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 overflow-hidden" style={{ backgroundColor: 'var(--color-warm-50)' }}>
        <WorkspaceModeRenderer onViewChange={onViewChange} />
      </div>

      <GoalSelectionWizard
        isOpen={showGoalWizard}
        onClose={() => setShowGoalWizard(false)}
        onGoalSelected={() => setShowGoalWizard(false)}
      />
    </div>
  )
}
